import './ItemPdfHeader.css'
import { standardName } from '../../utils/standardRef'

const REF_VALUE = '__ref__'

function optionLabel(item) {
  return `${standardName(item.standard) || 'Standard'}/${item.label || 'Section'}`
}

// Header content for the PDF viewer pane: the "Searchroom PDFs" title, a slash
// separator, then a dropdown of the room's items. Because two items from
// different standards can share a label, each option is prefixed with its
// standard for specificity (e.g. "AISC 360-22/Chapter F - Design of Members").
// `activeRef` is a section opened from a chat chip. It may not be one of the
// room's items, so it is shown as the current value until the reader picks
// something from the room list.
function ItemPdfHeader({ items = [], selectedId, onSelect, activeRef }) {
  const refId = activeRef?._id ? String(activeRef._id) : ''
  const inList = Boolean(refId && items.some((it) => String(it._id) === refId))
  const value = activeRef ? (inList ? refId : REF_VALUE) : selectedId || ''

  return (
    <div className="pdf-header">
      <span className="display-header-title">Searchroom PDFs</span>
      <span className="display-header-title pdf-header-sep">/</span>
      <select
        className="pdf-item-select"
        value={value}
        title={activeRef ? optionLabel(activeRef) : undefined}
        onChange={(event) => {
          if (event.target.value === REF_VALUE) return
          onSelect?.(event.target.value)
        }}
        disabled={items.length === 0 && !activeRef}
      >
        <option value="" disabled>
          {items.length || activeRef ? 'Select an item…' : 'No items'}
        </option>
        {activeRef && !inList ? <option value={REF_VALUE}>{optionLabel(activeRef)}</option> : null}
        {items.map((item) => (
          <option key={item._id} value={item._id}>
            {optionLabel(item)}
          </option>
        ))}
      </select>
    </div>
  )
}

export default ItemPdfHeader
